// src/services/directMessages.js - Direct Messages API Service
import api from './api';

/**
 * Fetch total count of unread messages for current user
 */
export const getUnreadDirectMessagesCount = async () => {
  try {
    const response = await api.get('/direct-messages/unread-count');
    return response.data?.unreadCount || 0;
  } catch (error) {
    console.error('getUnreadDirectMessagesCount error:', error);
    return 0;
  }
};

/**
 * Fetch conversations list with latest message and unread counts
 */
export const getDirectConversations = async () => {
  try {
    const response = await api.get('/direct-messages/conversations');
    const data = response.data;
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.conversations)) return data.conversations;
    return [];
  } catch (error) {
    console.error('getDirectConversations error:', error);
    return [];
  }
};

/**
 * Fetch full message thread with another user
 * @param {string} otherUserId
 */
export const getDirectMessageThread = async (otherUserId) => {
  try {
    const response = await api.get(`/direct-messages/${otherUserId}`);
    const data = response.data;
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.messages)) return data.messages;
    return [];
  } catch (error) {
    console.error('getDirectMessageThread error:', error);
    return [];
  }
};

/**
 * Send a new direct message
 * @param {Object} payload - { recipientId, message, studyId, context }
 */
export const sendDirectMessage = async ({ recipientId, message, studyId = null, context = null }) => {
  try {
    const response = await api.post('/direct-messages', {
      recipientId,
      message,
      studyId,
      context
    });
    return response.data?.message || response.data;
  } catch (error) {
    console.error('sendDirectMessage error:', error);
    throw error;
  }
};

/**
 * Mark messages from a specific sender as read
 * @param {string} senderId
 */
export const markDirectMessagesRead = async (senderId) => {
  try {
    const response = await api.patch('/direct-messages/mark-read', { senderId });
    return response.data;
  } catch (error) {
    console.error('markDirectMessagesRead error:', error);
    throw error;
  }
};
